import { getTime, getRelativeDayorCurrentDate, addTime } from '@utils/dates';
import { LMPSessionStatus, RecordingStatus } from '@constants/index';

const recordingStatusMessage = {
  [RecordingStatus.LEARNER_DID_NOT_JOIN]:
    'Missed session. No recording available',
  [RecordingStatus.RECORDING_NOT_AVAILABLE]: 'Recording not available'
};

const getRecordingMessage = (recordingStatus) => {
  return recordingStatus && recordingStatusMessage[recordingStatus]
    ? recordingStatusMessage[recordingStatus]
    : 'Recording available shortly';
};

const getCardOneDetails = (slot, status, isDarkModeOn, recordingStatus) => {
  let cardDetails = null;
  const sessionSlotDate = slot?.startTime;
  const sessionDate = getRelativeDayorCurrentDate(sessionSlotDate);
  const sessionDuration = slot?.durationInfo?.value;
  const sessionStartTime = getTime(sessionSlotDate);
  const sessionEndDate = addTime(
    new Date(sessionSlotDate),
    slot?.duration,
    'm'
  );
  const sessionEndTime = getTime(sessionEndDate);

  const getSessionImageAccordingToTime = (slotDate) => {
    const date = new Date(slotDate);
    const h = date.getHours();
    if (h >= 5 && h < 12) {
      return 'sessionTimeMorning.svg';
    }
    if (h >= 12 && h < 16) {
      return 'sessionAfternoonTime.svg';
    }
    return 'sessionNightTime.svg';
  };

  const formattedDate = `${sessionDate} • ${sessionStartTime} - ${sessionEndTime}`;
  if (!status) {
    return null;
  }
  if (
    status === LMPSessionStatus.UPCOMING ||
    status === LMPSessionStatus.STARTED
  ) {
    cardDetails = {
      largeHeading: formattedDate,
      smallHeading: `${sessionDuration} min session`,
      cardImage: getSessionImageAccordingToTime(sessionSlotDate)
    };
  } else if (status === LMPSessionStatus.STOPPED) {
    cardDetails = {
      largeHeading: getRecordingMessage(recordingStatus),
      cardImage: 'playSessionRecording.svg',
      faded: true
    };
  } else if (
    status === LMPSessionStatus.MODERATOR_CANCELLED ||
    status === LMPSessionStatus.EDUCATOR_CANCELLED
  ) {
    const cancelledDate = `${sessionDate} • ${sessionStartTime} • ${sessionDuration} min session`;
    cardDetails = {
      largeHeading: 'Cancelled by mentor',
      smallHeading: cancelledDate,
      cardImage: 'oneToOneLiveMentoring/cancelledSession.svg',
      faded: true
    };
  } else if (status === LMPSessionStatus.CANCELLED) {
    const cancelledDate = `${sessionDate} • ${sessionStartTime} • ${sessionDuration} min session`;
    cardDetails = {
      largeHeading: 'Cancelled by you',
      smallHeading: cancelledDate,
      cardImage: isDarkModeOn
        ? 'oneToOneLiveMentoring/darkModeCancelledSession.svg'
        : 'oneToOneLiveMentoring/cancelledSession.svg',
      faded: true
    };
  } else if (status === LMPSessionStatus.RECORDING_AVAILABLE) {
    const sessionRecordingDate = `${sessionDuration} min • ${sessionDate} • ${sessionStartTime}`;
    cardDetails = {
      largeHeading: 'Session recording',
      smallHeading: sessionRecordingDate,
      cardImage: 'sessionPlayRecording.svg'
    };
  } else {
    cardDetails = {
      largeHeading: formattedDate,
      smallHeading: `${sessionDuration} min session`,
      cardImage: getSessionImageAccordingToTime(sessionSlotDate)
    };
  }

  return cardDetails;
};

const getCardTwoDetails = (educator, status, isWelcomeSession = false) => {
  let cardDetails = null;
  if (educator?.uid) {
    cardDetails = {
      largeHeading: `${educator.firstName} ${educator.lastName}`,
      smallHeading: `${
        isWelcomeSession ? 'Your personal mentor' : 'Session mentors'
      }`,
      cardImage: educator.avatar
    };
  } else if (
    status === LMPSessionStatus.UPCOMING ||
    status === LMPSessionStatus.ASSIGNMENT_DUE ||
    status === LMPSessionStatus.REASSIGNED
  ) {
    cardDetails = {
      largeHeading: 'A mentor will be assigned shortly',
      cardImage: 'sessionEducator.svg',
      faded: true
    };
  }

  return cardDetails;
};

const getCardThreeDetails = (vertical = {}) => {
  if (!vertical?.uid) return {};
  const cardDetails = {
    largeHeading: vertical.parent.name,
    smallHeading: vertical.name,
    cardImage: vertical.parent.parent.icon
  };
  return cardDetails;
};

export {
  getCardOneDetails,
  getCardTwoDetails,
  getCardThreeDetails,
  getRecordingMessage
};
